import useToken from 'hooks/useToken';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Card, Spinner } from 'react-bootstrap';
import InfiniteScroll from 'react-infinite-scroll-component';
import { FiClock, FiWifi, FiCalendar, FiCheck, FiZap, FiActivity } from 'react-icons/fi';
import Skeleton from 'react-loading-skeleton';
import ImagenPerfil from '../../components/common/ImagenPerfil';
import { useToast } from 'context/providers/ToastProvider';


const HistorialMovimientosCliente = ({
    idCliente,
    setClienteActivityLogs,
    clienteActivityLogs
}) => {

    const { token, setToken } = useToken();
    const { showErrorToast } = useToast();
    const [paginaLogs, setPaginaLogs] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [cargando, setCargando] = useState(true);
    console.log(clienteActivityLogs)
    /*
      Carga 10 Logs por primera vez 
      **/
    useEffect(() => {
        if (idCliente) {
            // Resetear estados cuando cambia el cliente
            setClienteActivityLogs([]);
            setPaginaLogs(1);
            setHasMore(true);
            setCargando(true);

            fetchMoreLogs();
        }
    }, [idCliente]);

    const fetchMoreLogs = async () => {
        try {
            const response = await fetch('/api/cliente/ObtenerHistorialMovimientos', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify({
                    idCliente: idCliente,
                    pagina: paginaLogs,
                    tamanioPagina: 10
                })
            });

            if (response.ok) {
                const data = await response.json();
                if (data.iResponseType === 1) {
                    const parsed = JSON.parse(data.detalles);
                    const nuevosLogs = parsed.table2;
                    if (nuevosLogs && nuevosLogs.length > 0) {
                        // Si es la primera página, reemplazar en lugar de agregar
                        if (paginaLogs === 1) {
                            setClienteActivityLogs(nuevosLogs);
                        } else {
                            setClienteActivityLogs(prev => [...prev, ...nuevosLogs]);
                        }
                        setPaginaLogs(prev => prev + 1);

                        if (nuevosLogs.length < 10) {
                            setHasMore(false);
                        }
                    } else {
                        setHasMore(false);
                    }
                } else {
                    showErrorToast(data.vMessage);
                    setHasMore(false);
                }
            } else {
                showErrorToast(response.status + ' ' + response.statusText);
                if (response.status === 401) {
                    setToken(null);
                    location.href = '';
                }
                setHasMore(false);
            }
        } catch (error) {
            showErrorToast("Error inesperado al obtener logs");
            setHasMore(false);
        } finally {
            setCargando(false);
        }
    };

    // Skeleton Loading más sencillo
    const LogSkeleton = () => (
        <div style={{ padding: 0 }}>
            {[1, 2, 3, 4, 5].map((i) => (
                <div
                    key={i}
                    style={{
                        display: "flex",
                        alignItems: "center",
                        padding: "12px 16px",
                        borderBottom: "1px solid #e3e3e3",
                    }}
                >
                    <div style={{ flex: 2 }}>
                        <Skeleton height={20} width="70%" />
                    </div>
                    <div style={{ flex: 2, paddingLeft: 16 }}>
                        <Skeleton height={18} width="85%" />
                    </div>
                    <div style={{ flex: 1, paddingLeft: 16 }}>
                        <Skeleton height={16} width="60%" />
                    </div>
                    <div style={{ flex: 1, paddingLeft: 16 }}>
                        <Skeleton height={14} width="80%" />
                    </div>
                </div>
            ))}
        </div>
    );

    return (
        <Card className="mb-3 shadow-sm border-0">
            <Card.Header className="border-bottom bg-light">
                <div className="d-flex align-items-center">
                    <FiZap className="text-warning me-2" size={18} />
                    <h6 className="mb-0 fw-bold">Historial de Movimientos</h6>
                </div>
            </Card.Header>

            <Card.Body className="p-3" id="scrollableTargetLogsCliente" style={{ maxHeight: '350px', overflow: 'auto' }}>
                {cargando ? (
                    <LogSkeleton />
                ) : (
                    <InfiniteScroll
                        dataLength={clienteActivityLogs.length}
                        next={fetchMoreLogs}
                        hasMore={hasMore}
                        loader={
                            <div className="d-flex justify-content-center align-items-center py-3">
                                <Spinner animation="border" size="sm" variant="primary" className="me-2" />
                                <span className="text-muted" style={{ fontSize: '0.85rem' }}>Cargando m&aacute;s registros...</span>
                            </div>
                        }
                        scrollableTarget="scrollableTargetLogsCliente"
                        scrollThreshold={0.95}
                        endMessage={
                            clienteActivityLogs.length > 0 && (
                                <div className="text-center py-3 border-top">
                                    <small className="text-muted" style={{ fontSize: '0.8rem' }}>
                                        <FiCheck className="me-1" size={12} />
                                        Historial completo
                                    </small>
                                </div>
                            )
                        }
                    >
                        {clienteActivityLogs.length === 0 ? (
                            <div className="text-center py-5">
                                <FiClock className="text-muted mb-3" size={40} />
                                <h6 className="text-muted mb-2">Sin movimientos</h6>
                                <p className="text-muted mb-0" style={{ fontSize: '0.9rem' }}>
                                    No hay actividad registrada para mostrar
                                </p>
                            </div>
                        ) : (
                            <div className="position-relative ps-4">
                                {/* Línea principal del timeline */}
                                <div
                                    className="position-absolute bg-primary"
                                    style={{
                                        left: '22px',
                                        top: '30px',
                                        bottom: '30px',
                                        width: '2px',
                                        zIndex: 1
                                    }}
                                />

                                {clienteActivityLogs.map((log, index) => (
                                    <div key={index} className="position-relative mb-3 d-flex align-items-start">
                                        {/* Avatar del usuario centrado en la línea */}
                                        <div
                                            className="position-absolute bg-white border border-2 border-white rounded-circle shadow-sm d-flex align-items-center justify-content-center overflow-hidden"
                                            style={{
                                                left: '-22px',
                                                top: '0px',
                                                width: '44px',
                                                height: '44px',
                                                zIndex: 2
                                            }}
                                        >
                                            <ImagenPerfil
                                                idUsuario={log.idUsuario}
                                                placeholder={log.vNombre}
                                                style={{
                                                    width: '40px',
                                                    height: '40px',
                                                    borderRadius: '50%',
                                                    objectFit: 'cover'
                                                }}
                                            />
                                        </div>

                                        {/* Contenido del movimiento - Más compacto */}
                                        <div className=" border rounded-3 shadow-sm p-2 ms-4 w-100">
                                            {/* Nombre del usuario */}
                                            <div className="fw-bold text-dark mb-1" style={{ fontSize: '0.9rem' }}>
                                                {log.vNombre}
                                            </div>

                                            {/* Actividad/Movimiento */}
                                            <div className="bg-light rounded-2 p-2 mb-2 d-flex align-items-center">
                                                <FiActivity size={14} className="text-primary me-2" />
                                                <span className="fw-medium text-dark" style={{ fontSize: '0.82rem' }}>
                                                    {log.vMovimiento}
                                                </span>
                                            </div>

                                            {/* IP, Fecha y hora en una sola línea */}
                                            {log.dCreatedDate && (
                                                <div className="d-flex align-items-center text-muted" style={{ fontSize: '0.72rem' }}>
                                                    {/* IP */}
                                                    <div className="d-flex align-items-center me-3">
                                                        <FiWifi size={10} className="me-1 text-primary" />
                                                        <span>{log.vIP}</span>
                                                    </div>

                                                    {/* Fecha */}
                                                    <div className="d-flex align-items-center me-3">
                                                        <FiCalendar size={10} className="me-1" />
                                                        <span>
                                                            {new Date(log.dCreatedDate).toLocaleDateString('es-ES', {
                                                                day: '2-digit',
                                                                month: 'short',
                                                                year: 'numeric'
                                                            })}
                                                        </span>
                                                    </div>

                                                    {/* Hora */}
                                                    <div className="d-flex align-items-center">
                                                        <FiClock size={10} className="me-1" />
                                                        <span>
                                                            {new Date(log.dCreatedDate).toLocaleTimeString('es-ES', {
                                                                hour: '2-digit',
                                                                minute: '2-digit'
                                                            })}
                                                        </span>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </InfiniteScroll>
                )}
            </Card.Body>
        </Card>
    );
};

HistorialMovimientosCliente.propTypes = {
    idCliente: PropTypes.string,
    setClienteActivityLogs: PropTypes.func,
    clienteActivityLogs: PropTypes.array
};

export default HistorialMovimientosCliente;
